import React from 'react';
import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import Loader from 'ui-component/Loader';

import csvDownload from 'json-to-csv-export';

import value from 'assets/scss/_themes-vars.module.scss';

// material-ui
import { DataGrid } from '@mui/x-data-grid';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert } from '@mui/material';
import { Delete, DeleteOutlined } from '@mui/icons-material';
import { useTheme, makeStyles } from '@mui/material/styles';

import { getProjectsUser, deleteProject } from 'utils/firebase/firebase.utils';
import { UserContext } from '../../contexts/user.context';

const AllUsers = ({ users, isLoading, setSelectedRowsDataUsers }) => {
    const [selectionModel, setSelectionModel] = useState([]);
    const { currentUser } = useContext(UserContext);

    const convertData = (projectData) => {
        const dataToConvert = {
            data: projectData,
            filename: 'keyword-clustering',
            delimiter: ','
        };
        // console.log(projectData);
        return dataToConvert;
    };

    const handleSelectionModelChange = (newSelectionModel) => {
        setSelectionModel(newSelectionModel);

        const newSelectedRowsData = users.filter((row) => newSelectionModel.includes(row.createdAt));

        setSelectedRowsDataUsers(newSelectedRowsData);
    };

    const columns = [
        { field: 'email', headerName: 'Email', minWidth: 120, flex: 3 },
        { field: 'displayName', headerName: 'Display name', minWidth: 120, flex: 3 },

        { field: 'credits', headerName: 'Credits', minWidth: 80, flex: 2 },
        {
            field: 'createdAt',
            headerName: 'Created',
            minWidth: 120,
            flex: 3,
            renderCell: (params) => {
                return <div>{params.row.createdAt.toDate().toString()}</div>;
            }
        }
    ];

    if (isLoading) return <Loader />;

    return (
        <div style={{ width: '100%' }}>
            <DataGrid
                sx={{
                    border: 0,
                    '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
                        outline: 'none !important'
                    },
                    '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus': {
                        outline: 'none'
                    },
                    '.MuiDataGrid-columnSeparator': {
                        display: 'none'
                    },
                    '.MuiDataGrid-columnHeader--sortable': {
                        outline: 'none !important'
                    },
                    '.MuiDataGrid-columnHeaderTitle': {
                        color: 'text.dark'
                    }
                }}
                autoHeight
                disableSelectionOnClick
                rows={users}
                columns={columns}
                getRowId={(row) => row.createdAt}
                pageSize={10}
                checkboxSelection={true}
                onSelectionModelChange={handleSelectionModelChange}
                selectionModel={selectionModel}
            />
        </div>
    );
};

export default AllUsers;
